import { BannerSection, SectionSubtitle } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import * as React from 'react';
import { HistoryService } from 'web_core_library';
import { AssetsBaseUrl } from '../../base/env';

export interface IProps {
  onLearnMore?: () => void;
}

const GroupPackageSection: React.FC<IProps> = ({ onLearnMore }) => {
  const { t } = useTranslation();
  const title = t('prereg:Welcome.GroupPackageSection.Title');
  const descriptionHtml = t('prereg:Welcome.GroupPackageSection.DescriptionHtml');
  const imgSrc = `${AssetsBaseUrl}/feature/group_package.png`;
  const linkUrl = HistoryService.getInternalUrl('/lp/corp/?lang=de');
  return (
    <BannerSection direction="left" title={title} imgSrc={imgSrc}>
      <SectionSubtitle wrapperTag="div">{renderStringToReact(descriptionHtml, ETagType.div)}</SectionSubtitle>
      <a href={linkUrl} onClick={onLearnMore}>
        {t('prereg:Welcome.GroupPackageSection.Action')}
      </a>
    </BannerSection>
  );
};

export default GroupPackageSection;
